export default __webpack_public_path__ + "static/media/rhino.99472217.jpg";